const axios = require('axios');
const appconfig = require('../../app.config');

export const state = { 
    currentUser: getSavedState('auth.currentUser'),
}

export const getters = { 
    loggedIn(state) { 
        return !!state.currentUser
    },
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) { 
        state.currentUser = newValue;  
        saveState('auth.currentUser', newValue);  
    },
}

export const actions = {
    logIn({ commit }, { username, password } = {}) {
        return axios.request({
            url: appconfig.baseUrl + '/Login/CheckLogin',
            method: 'POST',
            data: { Username:username, Password:password } 
        }).then(response => {
            if (response.data.StatusCode == 200) {
                commit('SET_CURRENT_USER', response.data.ResponseData);
            }
            return response;
        })
    },

    logOut({ commit }) {
        commit('SET_CURRENT_USER', null)
    },

    validate({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null)
        const user =  state.currentUser;
        commit('SET_CURRENT_USER', user)
        return user;
    },
}

function getSavedState(key) {
    return JSON.parse(window.sessionStorage.getItem(key))
}

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}